<div>
    <!-- <app-header class="app_comp__header"></app-header> -->
    <router-outlet></router-outlet>
    <!-- <app-footer class="app_comp__footer"></app-footer> -->
    <!-- <app-toast-container></app-toast-container> -->
    <p-toast></p-toast>
</div>